import * as IActions from './interfaces/action';
import { ConversationSectionEnum } from '@/app-constants';

export const CONVERSATION_ACTIONS = {
  POST: 'CONVERSATION_POST',
  REQUEST: 'CONVERSATION_REQUEST',
  SUCCESS: 'CONVERSATION_SUCCESS',
  FAILURE: 'CONVERSATION_FAILURE',
  HIDE: 'CONVERSATION_HIDE',
  NOTES_POST: 'NOTES_POST',
  NOTES_POST_SUCCESS: 'NOTES_POST_SUCCESS',
  NOTES_REQUEST: 'NOTES_REQUEST',
  NOTES_REQUEST_SUCCESS: 'NOTES_REQUEST_SUCCESS',
  NOTES_FAILURE: 'NOTES_FAILURE'
};

export function conversationRequestAction(payload: IActions.IConversationRequestPayload) {
  payload.sectionId = payload.sectionId || ConversationSectionEnum.Conversation;
  payload.readOnly = !!payload.readOnly;
  return {
    payload,
    type: CONVERSATION_ACTIONS.REQUEST
  };
}

export function conversationPostAction(request: IActions.ICreateConversationMessagePayload) {
  return {
    request,
    type: CONVERSATION_ACTIONS.POST
  };
}

export function conversationSuccessAction(payload: IActions.IConversationSuccessPayload) {
  return {
    payload,
    type: CONVERSATION_ACTIONS.SUCCESS
  };
}

export function conversationFailureAction(error) {
  return {
    error,
    type: CONVERSATION_ACTIONS.FAILURE
  };
}

export function conversationHideAction() {
  return {
    type: CONVERSATION_ACTIONS.HIDE
  };
}

export const CREATE_CONVERSATION_ACTIONS = {
  POST: 'CREATE_CONVERSATION_POST',
  SUCCESS: 'CREATE_CONVERSATION_SUCCESS'
};

export function createConversationPostAction(request: IActions.ICreateConversationPayload) {
  return {
    request,
    type: CREATE_CONVERSATION_ACTIONS.POST
  };
}

export function createConversationSuccessAction(conversationId: number) {
  return {
    conversationId,
    type: CREATE_CONVERSATION_ACTIONS.SUCCESS
  };
}

export function notePostAction(payload: IActions.ICreateNotePayload) {
  return {
    payload,
    type: CONVERSATION_ACTIONS.NOTES_POST
  };
}

export function notePostSuccess() {
  return {
    type: CONVERSATION_ACTIONS.NOTES_POST_SUCCESS
  };
}

export function notesRequestAction(request: IActions.IGetNotesPayload) {
  return {
    request,
    type: CONVERSATION_ACTIONS.NOTES_REQUEST
  };
}

export function notesRequestSuccessAction(payload: IActions.INotesRequestSuccessPayload) {
  return {
    payload,
    type: CONVERSATION_ACTIONS.NOTES_REQUEST_SUCCESS
  };
}

export function notesFailureAction(error) {
  return {
    error,
    type: CONVERSATION_ACTIONS.NOTES_FAILURE
  };
}
